import script from "./UsuariosCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosCadastro.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosCadastro.vue?vue&type=style&index=0&id=5f26a255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f26a255"]])

export default __exports__